export function convertBase64ToBlob(data, type): Blob {
  let byteString = atob(data);
  const ab = new ArrayBuffer(byteString.length);
  let ia = new Uint8Array(ab);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type });
}

export async function convertBlobToBase64(file: Blob) {
  if (file != null && isBlob(file)) {
    return new Promise<string>((resolve, reject) => {
      try {
        const FileReader: new () => FileReader = (
          (window as any).FileReader as any
        ).__zone_symbol__OriginalDelegate;
        var reader = new FileReader();

        reader.onload = async () => {
          const binaryResult = reader.result as string;
          let data = btoa(binaryResult);
          resolve(data);
        };

        reader.onerror = (e) => {
          console.log(e);
          reject(e);
        };

        reader.readAsBinaryString(file);
      } catch (err) {
        reject(err);
      }
    });
  }
}

function isBlob(input: any): boolean {
  return "Blob" in window && input instanceof Blob;
}
